import { createContext, useContext } from 'react';

/**
 * True when a config editor is rendered read-only (the nested hierarchy's node
 * inspector), so it can drop heavy, interaction-only embellishments — e.g. the
 * run-workflow editor's live target-graph preview, which only stretches the
 * panel and adds nothing you can act on in a preview. Default false, so the
 * editor canvas is unchanged.
 */
const WorkflowNodeEditorReadOnlyContext = createContext(false);

export const WorkflowNodeEditorReadOnlyProvider =
  WorkflowNodeEditorReadOnlyContext.Provider;

export function useWorkflowNodeEditorReadOnly(): boolean {
  return useContext(WorkflowNodeEditorReadOnlyContext);
}
